import type { Prescription } from "@/core/clinical/types";
import {
  FULFILLMENT_STEPS,
  type FulfillmentStep,
  countLinesForStep,
  stepCompletion,
} from "@/core/clinical/prescription-fulfillment-steps";

interface PrescriptionFulfillmentStepperProps {
  prescription: Prescription;
  activeStep: FulfillmentStep;
  onStepChange: (step: FulfillmentStep) => void;
}

export function PrescriptionFulfillmentStepper({
  prescription,
  activeStep,
  onStepChange,
}: PrescriptionFulfillmentStepperProps) {
  return (
    <nav className="ph-fulfill-stepper" aria-label="Étapes de dispensation">
      <ol className="ph-fulfill-stepper-list">
        {FULFILLMENT_STEPS.map((step, index) => {
          const status = stepCompletion(prescription, step.id);
          const isSelected = activeStep === step.id;
          const count = countLinesForStep(prescription, step.id);

          return (
            <li
              key={step.id}
              className={`ph-fulfill-stepper-item ph-fulfill-stepper-item--${status}${
                isSelected ? " ph-fulfill-stepper-item--selected" : ""
              }`}
            >
              <button
                type="button"
                className="ph-fulfill-stepper-btn"
                onClick={() => onStepChange(step.id)}
                aria-current={isSelected ? "step" : undefined}
              >
                <span className="ph-fulfill-stepper-marker" aria-hidden>
                  {status === "done" ? "✓" : index + 1}
                </span>
                <span className="ph-fulfill-stepper-text">
                  <span className="ph-fulfill-stepper-label">{step.label}</span>
                  <span className="ph-fulfill-stepper-hint">{step.hint}</span>
                </span>
                {count > 0 && (
                  <span className="ph-fulfill-stepper-badge">{count}</span>
                )}
              </button>
              {index < FULFILLMENT_STEPS.length - 1 && (
                <span className="ph-fulfill-stepper-connector" aria-hidden />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
